// extracted by mini-css-extract-plugin
module.exports = {"card":"a10a3f92e9--card--Pkhyq","title":"a10a3f92e9--title--ty5o7","rate-info":"a10a3f92e9--rate-info--orymW","info-icon":"a10a3f92e9--info-icon--AUtJc"};